/**
 * A custom error class for cart implementation errors.
 *
 * @example
 * throw new CartImplementationError('This was not supposed to happen', {
 *   description: 'Product not found',
 *   productId: 123
 * })
 */
export class CartImplementationError extends Error {
    constructor(
        message: string,
        public details: {
            description: string;
            [k: string]: unknown;
        },
    ) {
        super(message);

        Object.defineProperty(this, "name", {
            value: new.target.name,
            enumerable: false,
            configurable: true,
        });

        Object.setPrototypeOf(this, new.target.prototype);
    }
}
